const MINIMUM_QUANTITY = [
    { valueObj: { min: 1, max: 5 }, id: 0, value: "1-5", label: "1 - 5 Ton" },
    { valueObj: { min: 5, max: 10 }, id: 1, value: "5-10", label: "5 - 10 Ton" },
    { valueObj: { min: 10, max: 15 }, id: 2, value: "10-15", label: "10 - 15 Ton" },
    { valueObj: { min: 15, max: 20 }, id: 3, value: "15-20", label: "15 - 20 Ton" },
    { valueObj: { min: 20, max: 25 }, id: 4, value: "20-25", label: "20 - 25 Ton" },
    { valueObj: { min: 25, max: Infinity }, id: 5, value: "25", label: "25+ Ton" }
];
const MINIMUM_QUANTITY_LIT = [
    { valueObj: { min: 1, max: 10 }, id: 6, value: "1-10000", label: "1 - 10k Ltr" },
    { valueObj: { min: 10, max: 20 }, id: 7, value: "10000-20000", label: "10k - 20k Ltr" },
    { valueObj: { min: 20, max: 30 }, id: 8, value: "20000-30000", label: "20k - 30k Ltr" },
    { valueObj: { min: 30, max: 40 }, id: 9, value: "30000-40000", label: "30k - 40k Ltr" },
    { valueObj: { min: 40, max: 50 }, id: 10, value: "40000-50000", label: "40k - 50k Ltr" },
    { valueObj: { min: 50, max: Infinity }, id: 11, value: "50000", label: "50k+ Ltr" }
];

export { MINIMUM_QUANTITY, MINIMUM_QUANTITY_LIT };
//# sourceMappingURL=minimumQuantity.js.map
